import SearchTerms from "./SearchTerms";
import EditSearchTerms from "./EditSearchTerms"
import Tabs from "../../../shared/components/Tabs";
import { useEffect, useState } from "react";

const Ontologies = (props) =>{

    const [Components, setComponents] = useState([
        {
            label: "User Search Terms",
            html: <SearchTerms></SearchTerms>
        },
        {
            label: "Edit Ontology Term",
            html: <EditSearchTerms></EditSearchTerms>

        }
    ]);



    return(
        <div>
            <Tabs
                Components = {Components}
            />
        </div>
    )
}

export default Ontologies;